export default "__VITE_ASSET__BsU8xgUr__"